import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";

import { SnackbarService } from "../../../../shared/services/snackbar.service";
import { ChangePasswordService } from "../../../services/change-password.service";
import { SessionStorageService } from "../../../services/session-storage.service";

import { config } from "../../../../../../config/index";
import { Subscription } from "rxjs";

@Component({
	selector: "change-password",
	template: require('./change-password.component.html'),
	styles: [require('./change-password.component.less')],
	providers: [ChangePasswordService, SnackbarService],
	preserveWhitespaces: true,
})
export class ChangePasswordComponent implements OnInit, OnDestroy {
	passwordDetails: any = {};
	valueRequired: boolean = false;
	_userRole: string;
	private _role = config.role;

	apiSubscription: Subscription;

	constructor(
		private _changePasswordService: ChangePasswordService,
		private _mdlSnackbarService: SnackbarService,
		private _sessionStorageService: SessionStorageService,
		private _router: Router
	) { }

	/**
	 * Function called to save changed password
	 * @param  {any} passwordDetails
	 */
	changePassword = (passwordDetails: any) => {
		this.apiSubscription?.unsubscribe();
		let passwordPattern = new RegExp(
			/(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[\W_])^.{6,}$/
		);
		if (
			passwordDetails.old_password &&
			passwordDetails.new_password &&
			passwordDetails.confirm_password
		) {
			if (passwordPattern.test(passwordDetails.new_password)) {
				if (
					passwordDetails.new_password ===
					passwordDetails.confirm_password
				) {
					this.apiSubscription = this._changePasswordService
						.changePassword(passwordDetails)
						.subscribe(
							(res: any) => {
								this.passwordChangeSuccessHandler(res);
							},
							(error) => {
								this.passwordDetails.confirm_password
									= this.passwordDetails.new_password
									= this.passwordDetails.old_password
									= null;
								this._mdlSnackbarService.showSnackbar(
									error.message, 'error'
								);
							}
						);
				} else {
					this.passwordDetails.confirm_password = null;
					this._mdlSnackbarService.showSnackbar("PASSWORD_NOT_MATCH", 'error');
				}
			} else {
				this._mdlSnackbarService.showSnackbar("PASSWORD_WRONG_FORMAT", 'error');
			}
		} else {
			this.valueRequired = true;
			this._mdlSnackbarService.showSnackbar("INCOMPLETE_DETAILS", 'error');
		}
	};

	passwordChangeSuccessHandler(res:any) {
		if (res.error_code === 103) {
			this._mdlSnackbarService.showSnackbar(
				"PASSWORD_LENGTH_ERROR", 'error'
			);
		} else {
			const accessTokenData: any = {};
			const roleData: any = {};
			const menuData: any = {};

			accessTokenData.token = res.data.token;
			roleData.roles = res.data.user.roles;
			roleData.default_role = roleData.roles.find(
				(roleItem: any) => roleItem.default_role === true
			).role;
			roleData.selectedRole = roleData.default_role;
			roleData.role = roleData.selectedRole.name;
			roleData.name =
				res.data.user.first_name + " " + res.data.user.last_name;
			roleData.first_name = res.data.user.first_name;
			menuData.menuList = roleData.selectedRole.menu_list;
			roleData.name =
				res.data.user.first_name +
				" " +
				res.data.user.last_name;
			this._changePasswordService.saveToken(
				"storage_key",
				accessTokenData
			);
			this._changePasswordService.saveToken(
				"role",
				roleData
			);
			this._changePasswordService.saveToken(
				"menu_list",
				menuData
			);

			this._mdlSnackbarService.showSnackbar(
				"PASSWORD_UPDATE_SUCCESS", 'success'
			);

			this.passwordDetails.confirm_password
				= this.passwordDetails.new_password
				= this.passwordDetails.old_password
				= null;
		}
	}

	/**
	 * Function called to fetch User Role
	 */
	userRoleFetch = () => {
		this._sessionStorageService.readItem(this._role).then((data: any) => {
			this._userRole = data.role;
		});
	};

	close() {
		this._router.navigate(["home/dashboard"]);
	}

	ngOnInit() {
		this.userRoleFetch();
	}

	ngOnDestroy() {
		this.apiSubscription?.unsubscribe();
	}
}
